import apiRequest from '../utils/apiRequest';
import findIdByPath from '../utils/findIdByPath';

const handleLoginResponse = res => {
  if (!res.token) {
    return {
      type: 'LOGIN_ERROR',
      res
    };
  } else {
    return {
      type: 'LOGIN_SUCCESS',
      res
    };
  }
};

const noAccess = () => ({
  type: 'NO_ACCESS'
});

const handleForgotResponse = res => {
  return {
    type: 'FORGOT',
    res
  };
};

const handleNewPasswordResponse = res => {
  return {
    type: 'NEW_PASSWORD',
    res
  };
};

const loggingIn = () => ({
  type: 'LOGGING_IN'
});

const loginBusy = () => ({
  type: 'LOGIN_BUSY'
});

export const logout = () => ({
  type: 'LOG_OUT'
});

export const login = (username, password) => async dispatch => {
  dispatch(loggingIn());

  const formData = new FormData();
  formData.append('username', username);
  formData.append('password', password);

  const response = await fetch(
    `${process.env.REACT_APP_WORDPRESS_URL}/jwt-auth/v1/token`,
    {
      method: 'POST',
      body: formData
    }
  );

  const jsonResponse = await response.json();

  if (jsonResponse.permissions === 0) {
    const hasLicense = jsonResponse.keys.some(
      a => JSON.stringify(a.book) === findIdByPath()
    );

    if (!hasLicense) {
      return dispatch(noAccess());
    }
  }

  return dispatch(handleLoginResponse(jsonResponse));
};

export const forgot = (username, endpoint) => async dispatch => {
  dispatch(loginBusy());

  const formData = new FormData();
  formData.append('user_email', username);
  formData.append('endpoint', endpoint);

  const response = await fetch(
    `${process.env.REACT_APP_WORDPRESS_URL}/userdata/v1/forgot`,
    {
      method: 'POST',
      body: formData
    }
  );

  const jsonResponse = await response.json();
  return dispatch(handleForgotResponse(jsonResponse));
};

export const newPassword = (email, key, password) => async dispatch => {
  dispatch(loginBusy());

  const formData = new FormData();
  formData.append('email', email);
  formData.append('key', key);
  formData.append('password', password);

  const response = await fetch(
    `${process.env.REACT_APP_WORDPRESS_URL}/userdata/v1/reset`,
    {
      method: 'POST',
      body: formData
    }
  );

  const jsonResponse = await response.json();
  return dispatch(handleNewPasswordResponse(jsonResponse));
};

const fetchReflections = () => async dispatch => {
  dispatch({ type: 'FETCHING_REFLECTIONS' });
  const reflections = await apiRequest('wordpress', 'reflections/v1/list');

  return dispatch({
    type: 'RECEIVE_REFLECTIONS',
    reflections: reflections || []
  });
};

export const fetchReflectionsIfNeeded = () => (dispatch, getState) => {
  const {
    user: { fetchingReflections }
  } = getState();
  if (fetchingReflections) return false;
  return dispatch(fetchReflections());
};



// WEBPACK FOOTER //
// ./src/actions/user.js